import React from "react";
import { CtaButton } from "./CtaButton";
import { Countdown } from "./Countdown";
import { ScarcityBar } from "./ScarcityBar";
type OfferBlockProps = {
  label: string;
  sub: string;
  id?: string;
  dark?: boolean;
};
export function OfferBlock({
  label,
  sub,
  id,
  dark = false
}: OfferBlockProps) {
  return <div className="mx-auto w-full max-w-xl" data-id="element-37" data-mp="4w08723w9q43">
      <CtaButton id={id} label={label} data-id="element-38" data-mp="4wtjmgdst3sk" />
      <p className={`mt-3 text-center text-sm ${dark ? "text-white/75" : "text-navy/70"}`} data-id="element-39" data-mp="skb5xwean9o5">{sub}</p>
      <Countdown dark={dark} data-id="element-40" data-mp="wmejqrofqqcl" />
      <ScarcityBar dark={dark} data-id="element-41" data-mp="wlmzgd0agf1m" />
    </div>;
}